import { motion } from 'framer-motion';
import { styled } from 'styled-components';

export const LogoContainer = styled(motion.div)`
  z-index: 4;
  position: relative;
  overflow: hidden;
  svg {
    z-index: 3;
    position: relative;
    display: block;
  }
`;
export const Logo = styled(motion.div)<{ inset?: number }>`
  z-index: 2;
  position: absolute;
  overflow: hidden;
  inset: ${(props) => props.inset ?? 3}px;
  border-radius: 16px;
  background: var(--pcm-body-background);
  svg,
  img {
    pointer-events: none;
    display: block;
    width: 100%;
    height: 100%;
  }
`;

export const SpinnerContainer = styled(motion.div)`
  position: absolute;
  inset: 1px;
  /* overflow: hidden; */
`;
export const Spinner = styled(motion.div)`
  pointer-events: none;
  user-select: none;
  z-index: 1;
  position: absolute;
  inset: -25%;
  &:before {
    content: '';
    position: absolute;
    inset: 0;
    background: conic-gradient(
      from -90deg,
      transparent,
      transparent,
      transparent,
      transparent,
      transparent,
      var(--pcm-accent-color)
    );
    animation: rotateSpinner 1200ms linear infinite;
  }
  @keyframes rotateSpinner {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;
